/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { APP_NAME } from "../lib/constants";
import api from "../services/api";

export default function Login() {
  const navigate = useNavigate();
  const { status } = useAuth();
  const [firstWord, ...restWords] = APP_NAME.split(" ");
  const restOfName = restWords.join(" ");
  
  const [loading, setLoading] = useState(false);

  // If already logged in, auto navigate to dashboard
  useEffect(() => {
    if (status === 'authenticated') {
      navigate('/dashboard');
    }
  }, [status, navigate]);

  useEffect(() => {
    // Sanitize body overflow locks
    document.body.style.overflow = "unset";
    document.body.style.pointerEvents = "auto";
    document.documentElement.style.overflow = "unset";
    document.documentElement.style.pointerEvents = "auto";
  }, []);

  const handleSSOLogin = async () => {
    setLoading(true);
    const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    sessionStorage.setItem('sso_state', state);
    const callbackUrl = `${window.location.origin}/auth/callback`;
    
    try {
      const res = await api.get('/health');
      const hubUrl = res.data.sso_hub_url || 'http://auth.hitclicks.test';
      window.location.href = `${hubUrl}/login?redirect=${encodeURIComponent(callbackUrl)}&state=${state}`;
    } catch (e) {
      console.error("Failed to fetch hub config", e);
      window.location.href = `http://auth.hitclicks.test/login?redirect=${encodeURIComponent(callbackUrl)}&state=${state}`;
    }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background with Glassmorphism */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden bg-slate-50">
        <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] rounded-full bg-blue-400/30 blur-[120px] animate-pulse" style={{ animationDuration: '7s' }} />
        <div className="absolute bottom-[-10%] right-[-5%] w-[60vw] h-[60vw] rounded-full bg-indigo-400/30 blur-[140px]" />
        <div className="absolute top-[20%] right-[10%] w-[40vw] h-[40vw] rounded-full bg-cyan-400/30 blur-[120px] animate-pulse" style={{ animationDuration: '5s' }} />
        <div className="absolute bottom-[20%] left-[5%] w-[45vw] h-[45vw] rounded-full bg-teal-400/20 blur-[130px]" />
        <div className="absolute inset-0 bg-white/70 backdrop-blur-[100px] backdrop-saturate-150" />
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10 flex flex-col items-center">
        <div className="flex items-center justify-center gap-3 mb-2">
          <div className="relative w-12 h-12 flex items-center justify-center">
            <img src="/academy_logo.png" alt="HitClicks Logo" className="object-contain w-full h-full drop-shadow-lg" />
          </div>
          <h2 className="text-center text-3xl font-black tracking-tighter drop-shadow-sm text-slate-900">
            {firstWord} <span className="brand-gradient">{restOfName}.</span>
          </h2>
        </div>
        <p className="text-center text-sm text-on-surface-variant font-bold">
          Log in to your account
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md animate-in fade-in zoom-in duration-700 relative z-10">
        <div className="bg-white/70 backdrop-blur-md py-10 px-6 shadow-2xl sm:rounded-[2.5rem] sm:px-10 border border-slate-200">
          
          <div className="space-y-6">
            <div className="text-center mb-8">
              <p className="text-sm text-slate-600 mb-2">We've upgraded our security!</p>
              <p className="text-xs text-slate-500">All users now sign in securely via the Central Auth Hub.</p>
            </div>
            <div className="space-y-4">
              <button
                onClick={handleSSOLogin}
                disabled={loading}
                className="w-full py-4 bg-primary text-on-primary rounded-[2rem] font-black text-xs uppercase tracking-widest hover:bg-primary/90 hover:-translate-y-0.5 active:scale-95 transition-all shadow-lg shadow-primary/20 disabled:opacity-50 disabled:translate-y-0 flex items-center justify-center gap-2"
              >
                <span className="material-symbols-outlined text-sm">login</span>
                {loading ? 'Redirecting to Hub...' : 'LOGIN'}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
